import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import notificationListenerMiddleware from "./middleware/notifications";
import dataEnteringListenerMiddleware from "../../features/dataEntering/redux/middleware";
import { api as accountingApi } from "../../services/accounting/api";
import { api as dataEnteringApi } from "../../services/dataEntering/api";
import { api as managementApi } from "../../services/management/api";
import { api as supervisingApi } from "../../services/supervising/api";
import { api as authApi } from "../../services/auth/api";
import { api as knowledgeApi } from "../../services/knowledge/api";

import * as Sentry from "@sentry/react";

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

export function configureAppStore() {
    const middlewares = [
        notificationListenerMiddleware.middleware,
        dataEnteringListenerMiddleware.middleware,
        accountingApi.middleware,
        dataEnteringApi.middleware,
        managementApi.middleware,
        supervisingApi.middleware,
        authApi.middleware,
        knowledgeApi.middleware,
    ];

    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ["@notify/ENQUEUE_NOTIFICATION"],
                },
            }).concat(middlewares),
        enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
    });
}

export const store = configureAppStore();
